import React, { useContext, useMemo } from "react";
import apolloTheme from "./Theme";
import { ThemeProvider as StyledComponentThemeProvider, ThemeContext } from "styled-components";
import { darkColors } from "./Colors";
import { GlobalStyle } from "./GlobalStyle";
export const getTheme = (mode) => {
    return mode === "light"
        ? apolloTheme
        : Object.assign(Object.assign({}, apolloTheme), { name: mode, colors: darkColors });
};
export const reverseThemeName = () => {
    const theme = useContext(ThemeContext);
    return theme.name === "light" ? "dark" : "light";
};
const ThemeProvider = ({ theme = "light", children }) => {
    const t = useMemo(() => getTheme(theme), [theme]);
    // consume the ThemeContext to increment the level
    const ctx = useContext(ThemeContext);
    const themeWithNewLevel = ctx ? Object.assign(Object.assign({}, t), { level: ctx.level + 1 }) : t;
    return (React.createElement(StyledComponentThemeProvider, { theme: themeWithNewLevel },
        React.createElement(GlobalStyle, { level: themeWithNewLevel.level }, children)));
};
export const ReverseThemeProvider = ({ children }) => (React.createElement(ThemeProvider, { theme: reverseThemeName() }, children));
export default ThemeProvider;
export { ThemeContext };
//# sourceMappingURL=ThemeProvider.js.map